<div class="PGTimePicker">
    <div class="input-group" #timepickerContainer>
        @if (!readonly) {
            <ngb-timepicker [(ngModel)]="value" (ngModelChange)="onValueChange()" [size]="size"></ngb-timepicker>
        }
        @if (readonly) {
            <div class="PGTimePicker-Readonly">
                <input disabled class="form-control" [ngModel]="getReadonlyHours()"/>
                <span>:</span>
                <input disabled class="form-control" [ngModel]="getReadonlyMinutes()"/>
            </div>
        }
    </div>
</div>